import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { newsEntriesPost, NewsEntryParam } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateNewsEntry = (
  options: UseMutationOptions<Blob, unknown, NewsEntryParam, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newsEntry) =>
      extractData(newsEntriesPost({ body: newsEntry, responseType: 'json' })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['newsEntries'],
      });
      options.onSuccess?.(...args);
    },
  });
};
